// refactor: remove swellAPI and use all data from loyaltyAPI
if (!customElements.get('points-table')) {
  customElements.define(
    'points-table',
    class BenefitList extends window.BAO.CustomElement {
      constructor() {
        super()

        this.leftToRetain = document.querySelector('.left-to-retain')
        this.statusRecieved = document.querySelector('.status-recieved')
        this.retainTier = document.querySelector('.retain-tier')
        this.pendingTier = document.querySelector('.pending')
        this.lifeTimePoints = document.querySelector('.lifetime-points')
        this.currentPoints = document.querySelector('.current-points')
        this.pointsTableinit = this.pointsTableinit.bind(this)
        this.nextTier = document.querySelector('.next-tier-level')

        this.card3 = this.querySelector('.yotpo-points_card.tier-3')
        this.card2 = this.querySelector('.yotpo-points_card.tier-2')
        this.card1 = this.querySelector('.yotpo-points_card.tier-1')
        this.blackOps = this.querySelector('.yotpo-points_card.black-ops')

        // this.tierInfo = null

        const customerquery = this.getCustomer.bind(this)

        // get customer details from swellAPI
        function waitForSwellData() {
          return new Promise(resolve => {
            const checkInterval = setInterval(() => {
              if (typeof swellAPI === 'undefined') {
                return
              }
              // eslint-disable-next-line no-undef
              const customer = swellAPI?.getCustomerDetails();
              if (customer && customer.email !== null && customer.vipTierStats !== null) {
                clearInterval(checkInterval)
                customerquery(customer)
                resolve(customer)
              }
            }, 1000)
          })
        }

        const initializePointsTable = async () => {
          const customer = await waitForSwellData();
          this.pointsTableinit(customer);
        }

        initializePointsTable()
      }

      pointsTableinit(customer) {
        this.customer = customer;
        this.tier = this?.customer?.vipTier?.name;
      }

      // set active tier card and populate progress bars...
      setTier(tier, tierRes, customer) {
        // caveat added for misc issue with tierRes length
        if (tierRes.length === 6) {
          tierRes = tierRes.slice(1)
        }
        // eslint-disable-next-line no-console
        console.log('Tier Response:', tierRes, 'Customer Object:', customer)
        let inTier = false;

        // retention
        const pointsToRetain = document.querySelector('.points-to-retain--indicator')
        const pointsToRetainLeft = document.querySelector('.points-to-retain')
        const activePointsRetention = document.querySelector('.active-points-retention')
        const pointsNeeded = customer?.vip_tier_maintenance_requirements?.points_needed
        pointsToRetainLeft.innerText = `${pointsNeeded}`

        // progression
        const pointsProgression = document.querySelector('.points-to-progress--indicator')
        const pointsProgressionLeft = document.querySelector('.points-to-progress')
        const activePointsProgression = document.querySelector('.active-points-progress')
        const pointsProgressionNeeded = customer.vip_tier_upgrade_requirements.points_needed
        pointsProgressionLeft.innerText = `${pointsProgressionNeeded}`

        // set tier 3 -- DONE.
        if (tier === 'TIER 3') {
          inTier = true;
          // set card
          const tier3 = this.querySelector('.tier-3')
          tier3.classList.add('active', 'current');
          this.nextTier.innerText = 'TIER 2'

          // retention
          // document.querySelector('.tier-rention--retention').style.display = 'none'
          // document.querySelector('.yotpo-points_card.current .yotpo-points_card__sub-title--completed').style.display = 'none'

          const retention = tierRes[0].retain_threshold.points_earned
          pointsToRetain.innerText = retention

          const needed = retention - pointsNeeded
          activePointsRetention.innerText = needed

          // retention percentage
          // const percentage = (needed / retention) * 100 // commented out to fix issue with NaN
          const percentage = isNaN(needed / retention) ? 100 : (needed / retention) * 100;

          const progressBarFill = document.querySelector('.tier-retention__progress-bar__fill--retention')
          progressBarFill.style.width = `${percentage}%`

          // retainer caveat 
          if (percentage >= 100) {
            const retainerCaveat = document.querySelector('.tier-retention__sub-title--retainer')
            retainerCaveat.innerHTML = 'Congratulations, you have retained your tier. When your tier expires you can enjoy another year in your tier.'
          }

          // progression
          const progression = tierRes[1].retain_threshold.points_earned
          pointsProgression.innerText = progression

          const neededProgression = progression - pointsProgressionNeeded
          activePointsProgression.innerText = neededProgression
          // progression percentage
          const percentageProgression = (neededProgression / progression) * 100
          const progressBarFillProgression = document.querySelector('.tier-retention__progress-bar__fill--progression')
          progressBarFillProgression.style.width = `${percentageProgression}%`

        }

        // set tier 2 -- DONE. 
        if (tier === 'TIER 2') {
          inTier = true;
          // set card
          this.querySelector('.tier-3').classList.add('active');
          const tier2 = this.querySelector('.tier-2')
          tier2.classList.add('active', 'current');
          this.nextTier.innerText = 'TIER 1'

          // retention
          const retention = tierRes[1].retain_threshold.points_earned
          pointsToRetain.innerText = retention

          const needed = retention - pointsNeeded
          activePointsRetention.innerText = needed

          // retention percentage
          const percentage = (needed / retention) * 100
          const progressBarFill = document.querySelector('.tier-retention__progress-bar__fill--retention')
          progressBarFill.style.width = `${percentage}%`

          // retainer caveat 
          if (percentage >= 100) {
            const retainerCaveat = document.querySelector('.tier-retention__sub-title--retainer')
            retainerCaveat.innerHTML = 'Congratulations, you have retained your tier. When your tier expires you can enjoy another year in your tier.'
          }

          // progression
          const progression = tierRes[2].retain_threshold.points_earned
          pointsProgression.innerText = progression

          const neededProgression = progression - pointsProgressionNeeded
          activePointsProgression.innerText = neededProgression
          // progression percentage
          const percentageProgression = (neededProgression / progression) * 100
          const progressBarFillProgression = document.querySelector('.tier-retention__progress-bar__fill--progression')
          progressBarFillProgression.style.width = `${percentageProgression}%`

        }

        // set tier 1 -- DONE.
        if (tier === 'TIER 1') {
          inTier = true;
          // set card
          this.querySelector('.tier-3').classList.add('active');
          this.querySelector('.tier-2').classList.add('active');
          const tier1 = this.querySelector('.tier-1')
          tier1.classList.add('active', 'current');
          this.nextTier.innerText = 'BLACK OPS'

          // retention
          const retention = tierRes[2].retain_threshold.points_earned
          pointsToRetain.innerText = retention

          const needed = retention - pointsNeeded
          activePointsRetention.innerText = needed

          // retention percentage
          const percentage = (needed / retention) * 100
          const progressBarFill = document.querySelector('.tier-retention__progress-bar__fill--retention')
          progressBarFill.style.width = `${percentage}%`

          // retainer caveat 
          if (percentage >= 100) {
            const retainerCaveat = document.querySelector('.tier-retention__sub-title--retainer')
            retainerCaveat.innerHTML = 'Congratulations, you have retained your tier. When your tier expires you can enjoy another year in your tier.'
          }

          // progression
          const progression = tierRes[3].retain_threshold.points_earned + 1500 // add 1500 points for progression
          pointsProgression.innerText = progression

          const neededProgression = progression - pointsProgressionNeeded
          activePointsProgression.innerText = neededProgression
          // progression percentage
          const percentageProgression = (neededProgression / progression) * 100
          const progressBarFillProgression = document.querySelector('.tier-retention__progress-bar__fill--progression')
          progressBarFillProgression.style.width = `${percentageProgression}%`

        }

        // set black ops -- DONE.
        if (tier === 'BLACK OPS' || tier === 'BLACK OPS (Lifetime)') {
          inTier = true;
          this.querySelector('.tier-3').classList.add('active');
          this.querySelector('.tier-2').classList.add('active');
          this.querySelector('.tier-1').classList.add('active');
          const blackOps = this.querySelector('.black-ops')
          blackOps.classList.add('active', 'current');

          // no need to show progression
          const progression = document.querySelector('.tier-rention--progression')
          progression.style.display = 'none'

          // retention
          const retention = tierRes[3].retain_threshold.points_earned
          pointsToRetain.innerText = retention

          const needed = retention - pointsNeeded
          activePointsRetention.innerText = needed

          // retention percentage
          const percentage = (needed / retention) * 100
          const progressBarFill = document.querySelector('.tier-retention__progress-bar__fill--retention')
          progressBarFill.style.width = `${percentage}%`

          // retainer caveat 
          if (percentage >= 100) {
            const retainerCaveat = document.querySelector('.tier-retention__sub-title--retainer')
            retainerCaveat.innerHTML = 'Congratulations, you have retained your tier. When your tier expires you can enjoy another year in your tier.'
          }

          // hide retention block for lifetime... 
          if (tier === 'BLACK OPS (Lifetime)') {
            const retentionContainer = document.querySelector('.tier-rention--retention')
            retentionContainer.style.display = 'none'
            // hide the points history
            const lifetimePoints = document.querySelector('.open-points-modal')
            lifetimePoints.style.display = 'none'

            setTimeout(() => {
              const removeDate = document.querySelector('.yotpo-points_card.current .yotpo-points_card__sub-title--completed')
              removeDate.innerHTML = 'Black Ops (By Invitation)'
            })
          }

        }

        // add expiry date to current tier
        const expiry = customer.vip_tier_expiration
        const expiryDate = new Date(expiry).toLocaleDateString()
        const dateString = `Until ${expiryDate}`
        const currentTier = document.querySelector('.yotpo-points_card.current .yotpo-points_card__sub-title--completed')
        if (currentTier != null) {
          currentTier.innerText = `${dateString}`
        }


        if (!inTier) {
          document.querySelector('.tier-rention.tier-rention--progression').style.display = 'none'
          document.querySelector('.tier-rention.tier-rention--retention').style.display = 'none'
          document.querySelector('.open-points-modal').style.display = 'none'
          document.querySelector('.rewards-title p').innerText = 'Make a purchase to earn points and unlock rewards'
          document.querySelector('.go-dark-benefits-container').style.display = 'none'
          document.querySelector('.yotpo-points_card.tier-3').classList.add('show-for-mobile')
        }
      }

      // get tiers
      getTiers(currentTier, customer) {

        const cus = customer
        let tierRes = null

        const card3 = this.card3
        const card2 = this.card2
        const card1 = this.card1
        const blackOps = this.blackOps

        const options = {
          method: 'GET',
          headers: {
            accept: 'application/json',
          },
        };

        fetch('https://loyalty.yotpo.com/api/v2/vip_tiers?guid=ywBcF-wPqa673Rpe0OTxtw&api_key=VMpi48DYWHYm2EhepMs1Awtt', options)
          .then(res => res.json())
          .then(res => {
            tierRes = res
            // set tiers
            card3.querySelector('.yotpo-points_card__sub-title').innerText = res[0].description
            card2.querySelector('.yotpo-points_card__sub-title').innerText = res[1].description
            card1.querySelector('.yotpo-points_card__sub-title').innerText = res[2].description
            blackOps.querySelector('.yotpo-points_card__sub-title').innerText = res[3].description

            // update tiers
            this.setTier(currentTier, tierRes, cus)

          })
          .catch(err => console.error(err));

      }

      // Get customer details
      getCustomer(customer) {

        const options = {
          method: 'GET',
          headers: { accept: 'application/json', 'content-type': 'application/json' },
        };
        fetch(`https://loyalty.yotpo.com/api/v2/customers?with_history=true&guid=ywBcF-wPqa673Rpe0OTxtw&api_key=VMpi48DYWHYm2EhepMs1Awtt&customer_email=${customer.email}`, options)
          .then(response => response.json())
          .then(response => {

            // title
            const userTier = response.vip_tier_name
            if (userTier != null && userTier !== undefined) {
              const currentTier = document.querySelectorAll('.current-tier-level')
              currentTier.forEach(tier => {
                if (userTier === 'BLACK OPS (Lifetime)') {
                  tier.innerHTML = 'BLACK OPS (By Invitation)'
                }
                else {
                  tier.innerHTML = userTier
                }
              })
            }

            // date
            const tierDate = document.querySelector('.tier-entry-date')
            const date = new Date(response.vip_tier_entry_date).toLocaleDateString()
            tierDate.innerHTML = date

            // create history rows
            const history = response.history_items
            const historyTable = document.querySelector('.history-table')
            let progressionTotal = 0
            history.forEach(item => {
              const row = document.createElement('div')
              row.classList.add('history-row')
              const date = new Date(item.created_at).toLocaleDateString()
              const status = item.status
              const points = item.points
              let pointsNoPending = 0
              if (status === 'Pending') {
                pointsNoPending = 0
              } else {
                pointsNoPending = points
              }
              const reason = item.action
              // const orderId = item.order_ids?.[0] || `${reason}`; // order ids not useful at the moment
              const orderId = `${reason}`;
              progressionTotal += pointsNoPending
              if (status === 'Pending') {
                row.innerHTML = `<div>${date}</div><div>${orderId}</div><div>${points}</div><div>0</div><div>${progressionTotal}</div>`
              } else {
                row.innerHTML = `<div>${date}</div><div>${orderId}</div><div>0</div><div>${points}</div><div>${progressionTotal}</div>`
              }
              historyTable.prepend(row)
            })

            const tier = response.vip_tier_name
            this.getTiers(tier, response)

          })
          .catch(err => console.error(err));
      }

    },
  )
}
